/* eslint-disable react/no-multi-comp */
import { Button, FormControlLabel, Radio, RadioGroup, CircularProgress } from 'material-ui';
import LeftArrowIcon from 'material-ui-icons/ArrowBack';
import RightArrowIcon from 'material-ui-icons/ArrowForward';
import EventIcon from 'material-ui-icons/Event';
import { DatePicker } from 'material-ui-pickers';
import { withStyles } from 'material-ui/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { translate } from 'react-i18next';
import { isEdge } from '../../../services/browserDetector';
import AbstractSearchForm from '../AbstractSearchForm';
import FullTextSearchField from '../FullTextSearchField';
import Room from '../Room';
import { setSelectedSuggestionFactory } from './../CommonFunctions';
import SearchTransferController from './SearchTransferController';
import { Typography } from 'material-ui';
import TimePicker from '../TimePicker';

const styles = {
    avatar: {
        backgroundColor: 'dark-grey',
        color: 'grey',
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    roomNumberTextField: {
        width: '140px',
        marginBottom: '32px',
    },
    footNoteText: {
        marginTop: '16px',
        fontWeight: 300,
        paddingTop: 0
    },
    dialogTitle: {
        fontWeight: '300',
        fontSize: '24px'
    },
    main: {

    }
};
/**
 * Componente de busqueda translados
 *
 * @author Luciano Bustos
 *
 */
let temp = Array.from(Array(46).keys());
temp.shift();
const adultValues = temp;
const kidsValues = Array.from(Array(21).keys());
class SearchTransfer extends AbstractSearchForm {
    constructor(props) {
        super(props);
        this.controller = new SearchTransferController(this.props, this);
        this.state = this.controller.getInitialState();
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        if (nextProps) {
            this.controller.getStateFromParams();
        }
    }
    componentDidMount() {
        this.controller.getStateFromParams();
        this.setState({ loading: false });
    }

    handleClose = () => {
        this.props.onClose(this.state);
    };

    handleCancel = () => {
        this.props.onClose(null);
    };


    handleEnter = () => {

    };

    render() {
        const { classes, t, from } = this.props;
        const room = this.state.rooms[0];
        return (
            <table width="100%" className="cmsSearchTransfer cmsTable">
                <tbody>
                    <tr>
                        <td colSpan="4"> <FullTextSearchField
                            setSelectedSuggestion={this.controller.originSelected}
                            endpoint="transfers/origin/fts"
                            value={from}
                            inputError={this.state.inputError}
                            placeHolder={'TRANSFERS.AIRPORT_ZONE_HOTEL_NAME'}
                            label={'COMMON.FROM'}
                        /> </td>
                    </tr>
                    <tr>
                        <td colSpan="4">
                            <FullTextSearchField
                                setSelectedSuggestion={setSelectedSuggestionFactory(this, 'to')}
                                endpoint="transfers/destination/fts"
                                componentRef={this.controller.destinationFTS}
                                value={this.state.to}
                                inputError={this.state.inputError}
                                originCode={this.state ? this.controller.getOriginZone(this.state.from) : ''}
                                autofocus={false}
                                placeHolder={'TRANSFERS.AIRPORT_ZONE_HOTEL_NAME'}
                                label={'COMMON.TO'}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="4">
                            <RadioGroup
                                aria-label="Transfer Type" row={true}
                                name="transferType"
                                onChange={this.controller.handleTransferTypeChange}
                                value={this.state.transferType}>
                                <FormControlLabel value="roundtrip" labelplacement="end"
                                    control={<Radio style={{ color: 'var(--primary-text-color)' }} />} label={t('TRANSFERS.ROUND_TRIP')} />
                                <FormControlLabel value="oneway" labelplacement="end"
                                    control={<Radio style={{ color: 'var(--primary-text-color)' }} />} label={t('TRANSFERS.ONE_WAY')} />
                            </RadioGroup>
                        </td>
                    </tr>
                    <tr className="cmsDateTransfer">
                        <td><DatePicker
                            margin="normal"
                            keyboard
                            className="cmsFormContainer"
                            label={t('TRANSFERS.DATE_FROM')}
                            format={'DD/MM/YYYY'}
                            leftArrowIcon={<LeftArrowIcon />}
                            rightArrowIcon={<RightArrowIcon />}
                            disablePast
                            autoOk
                            InputLabelProps={{
                                className: classes.inputLabelDate,
                            }}
                            keyboardIcon={
                                <EventIcon
                                    className={isEdge() ? classes.coloredIconIE : classes.coloredIcon}
                                />
                            }
                            value={this.state.fromDateTime}
                            onChange={this.controller.handleDateChange}
                        /></td>
                        <td>
                            <TimePicker
                                margin="normal"
                                label={t('TRANSFERS.HOUR_FROM')}
                                className=""
                                hourValue={this.state.fromDateTime.hour()}
                                minutesValue={this.state.fromDateTime.minutes()}
                                onChange={this.controller.handleHourChange}
                                >
                            </TimePicker>
                        </td>
                        <td>
                            <DatePicker
                                margin="normal"
                                keyboard
                                className={'cmsFormContainer ' + (this.state.datePickerStatus ? 'disabled' : '')}
                                label={t('TRANSFERS.DATE_TO')}
                                format={'DD/MM/YYYY'}
                                leftArrowIcon={<LeftArrowIcon />}
                                rightArrowIcon={<RightArrowIcon />}
                                disablePast
                                autoOk
                                InputLabelProps={{
                                    className: classes.inputLabelDate,
                                }}
                                keyboardIcon={
                                    !this.state.datePickerStatus ?
                                        <EventIcon
                                            className={isEdge() ? classes.coloredIconIE : classes.coloredIcon}
                                        /> : ''
                                }
                                value={this.state.toDateTime}
                                onChange={this.controller.handleToDateChange}
                                disabled={this.state.datePickerStatus}
                            />
                        </td>
                        <td>                          
                            <TimePicker
                                margin="normal"
                                label={t('TRANSFERS.HOUR_TO')}
                                className=""
                                hourValue={this.state.toDateTime.hour()}
                                minutesValue={this.state.toDateTime.minutes()}
                                onChange={this.controller.handleToHourChange}
                                disabled={this.state.datePickerStatus}
                            />
                        </td>

                    </tr>
                    <tr>
                        <td colSpan="4">
                            <Room
                                key={0}
                                displayIcon={false}
                                displayTitle={false}
                                adultValues={adultValues}
                                kidsValues={kidsValues}
                                loading={false}
                                number={0}
                                {...room}
                                handleAdultChange={this.handleAdultChange}
                                handleKidsChange={this.handleKidsChange}
                                handleKidsAgeChange={this.handleKidsAgeChange}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="2">
                            <Typography className="caption-form-description">{t('HOME.REQUIRED_FIELD')}</Typography>
                            <Typography className="caption-form-description">{t('HOME.BABIES_AS_CHILDREN')}</Typography>
                        </td>
                        <td colSpan="2">
                            <Button
                                variant="raised"
                                color="secondary"
                                onClick={this.controller.submit}
                                size={'large'}
                                fullWidth
                                className="cmsButtonSearch cmsButtonTransfer">
                                {this.state.loading && <CircularProgress size={18} className="buttonProgressIcon" />}
                                {t('TRANSFERS.SEARCH_BUTTON')}
                            </Button>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }
}

SearchTransfer.propTypes = {
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func,
};
export default translate('translations')(withStyles(styles)(SearchTransfer));


// WEBPACK FOOTER //
// ./src/components/SearchContent/Transfers/SearchTransfer.js